<template>
  <div id="app">
    <HelloWorld />
  </div>
</template>

<script>
import HelloWorld from './components/HelloWorld.vue'

const tp = require('tp-js-sdk')
const userAgent = window.navigator.userAgent
const isAndroid = userAgent.indexOf('Android') > -1 || userAgent.indexOf('Adr') > -1
if (isAndroid || window.history.length <= 1) {
  tp.fullScreen({
    fullScreen: 1
  })
}

export default {
  name: 'App',
  components: {
    HelloWorld
  },
}
</script>

<style lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
body{
  margin: 0;
  border: 0;
}
*{
  box-sizing: border-box;
  text-decoration: none;
}
a{
  -webkit-tap-highlight-color:rgba(0,0,0,0)
}
p{
  margin: 0;
  padding: 0;
}
body {
  background-color: black;
  left: 0;
  right: 0;
  margin: auto;
  overflow: hidden;
  //border: #DDDDDD 1px solid;
}
</style>
